import { createSelector } from 'reselect';
import { buildOptionsFromArray } from '../../utils/buildOptionsFromArray';

const seriesSelector = state => state.series;

export const current = createSelector(seriesSelector, state => state.current);
export const series = createSelector(seriesSelector, state => state.series);
export const seriesMap = createSelector(seriesSelector, state => state.seriesMap);
export const posts = createSelector(seriesSelector, state => state.posts);
export const seriesQuery = createSelector(seriesSelector, state => state.seriesQuery);
export const loading = createSelector(seriesSelector, state => state.loading);
export const scope = createSelector(seriesSelector, state => state.seriesScope);
export const types = createSelector(seriesSelector, state =>
  buildOptionsFromArray(
    [
      { key: 'All', value: 'All' },
      { key: 'Promoted Series', value: 'promoted' },
      { key: 'Editorial Series', value: 'editorial' },
      { key: 'Single Promoted Article', value: 'single' },
    ],
    'key',
    'value'
  )
);
